// @flow
import type { CookieInterface, ExpressParams } from '@rover/react-lib/types';
import reportError from '@rover/utilities/reportError';

import getCookieDomain from './getCookieDomain';
import getCookieByName from './getCookieByName';
import getExpires from './getExpires';

const PATH = '/';

const getDomain = () => getCookieDomain(window.location.hostname);

export const getCookie = (name: string, expressParams: ?ExpressParams): ?string => {
  if (expressParams) {
    reportError('Error in cookie.client.js: expressParams were unexpectedly present.');
  }

  return getCookieByName(name, document.cookie);
};

export const createCookie = (
  name: string,
  value: string,
  days: number,
  expressParams: ?ExpressParams
) => {
  if (expressParams) {
    reportError('Error in cookie.client.js: expressParams were unexpectedly present.');
  }

  const expires = getExpires(days).toUTCString();
  document.cookie = `${name}=${value};expires=${expires};domain=${getDomain()};path=${PATH}`;
};

export const removeCookie = (name: string) => {
  if (!getCookie(name)) return;
  document.cookie = `${name}=;path=${PATH};domain=${getDomain()};expires=Thu, 01 Jan 1970 00:00:01 GMT`;
};

export const hasCookie = (name: string): boolean => !!getCookie(name);

const cookie: CookieInterface = { getCookie, createCookie, removeCookie, hasCookie };

export default cookie;



// WEBPACK FOOTER //
// ../utilities/cookie/cookie.client.js